import React, { useState } from 'react';
import { Card, Modal, Button } from 'react-bootstrap';
import {Link} from "react-router-dom";

interface PostProps {
  post: {
    tokenId: string;
    title: string;
    authorName: string;
    authorAddress: string;
    content: string;
    description?: string;
  };
}

const Post: React.FC<PostProps> = ({ post }) => {
  const [showModal, setShowModal] = useState(false);
  const [externalLink, setExternalLink] = useState('');

  // Handle link clicks
  const handleLinkClick = (link: string) => {
    setExternalLink(link);
    setShowModal(true);
  };

  // Render content with clickable links
  const renderContent = (content: string) => {
    // Regex to find URLs in the content
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = content.split(urlRegex);
    
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        // If the part is a link, make it clickable
        return (
          <span
            key={index}
            style={{ color: '#00bfff', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => handleLinkClick(part)}
          >
            {part}
          </span>
        );
      } else {
        // Otherwise, render the plain text
        return part;
      }
    });
  };

  // Handle external link navigation
  const handleProceed = () => {
    setShowModal(false);
    window.open(externalLink, '_blank');
  };

  return (
    <Card className="post-card mb-4" style={cardStyle}>
      <Card.Body>
        <Card.Title style={titleStyle}>{post.title}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted" style={subtitleStyle}>
          By: {post.authorName}
        </Card.Subtitle>
        <Link style={{textDecoration:"none"}} to={`/search-results?type=Member&value=${post.authorAddress}`}> <Card.Subtitle className="mb-2 text-muted" style={subtitleStyle}>
          Address Minted: {post.authorAddress}
        </Card.Subtitle></Link>
        <hr />
        <Card.Text style={contentStyle}>
          {post.content ? renderContent(post.content) : 'No content available.'}
        </Card.Text>
        {post.description && (
          <Card.Text style={descriptionStyle}>
            <strong>Description:</strong> {post.description}
          </Card.Text>
        )}
      </Card.Body>
      <Link style={{textDecoration:"none"}} to={`/search-results?type=Post&value=${post.tokenId}`}> <Card.Footer className="text-muted" style={footerStyle}>
        Token ID: {post.tokenId}
      </Card.Footer>
      </Link>

      {/* Speedbump Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Leaving tgether.io</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You are about to leave tgether.io and go to "{externalLink}". Would you like to proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleProceed}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

// Inline styles for customization
const cardStyle: React.CSSProperties = {
  backgroundColor: '#1e1e2f',
  color: '#ffffff',
  border: '1px solid #4e4e6b',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
};

const titleStyle: React.CSSProperties = {
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '#f8f9fa',
};

const subtitleStyle: React.CSSProperties = {
  fontSize: '1rem',
  color: '#9e9eb1',
};

const contentStyle: React.CSSProperties = {
  fontSize: '1rem',
  color: '#cfcfd8',
  marginTop: '15px',
};

const descriptionStyle: React.CSSProperties = {
  fontSize: '0.9rem',
  color: '#a8a8b3',
  marginTop: '10px',
};

const footerStyle: React.CSSProperties = {
  backgroundColor: '#2c2c3c',
  color: '#9e9eb1',
  borderTop: '1px solid #4e4e6b',
  padding: '10px',
  borderRadius: '0 0 8px 8px',
};

export default Post;
